import type { LexicalNode } from 'lexical';
import { $isElementNode } from 'lexical';

import { $isDragHandleElementNode } from 'js/src/data/transcript/nodes/DragHandleElementNode';
import { $isSceneNumberNode } from 'js/src/data/transcript/nodes/SceneNumberNode';
import { $isSilenceNode } from 'js/src/data/transcript/nodes/SilenceNode';
import type { TextCorrectElementNode } from 'js/src/data/transcript/nodes/TextCorrectElementNode';
import { $dfsWithinNode, $isTrimmedOut } from 'js/src/data/transcript/transcript-utils';

export const $isWindowBarrierNode = (node: LexicalNode) => {
    return $isSilenceNode(node) || $isDragHandleElementNode(node);
};

export const $isIgnorableNodeForSaving = (node: LexicalNode) => {
    return $isElementNode(node) || $isTrimmedOut(node) || $isSceneNumberNode(node);
};

export const $getTextCorrectedWindows = (textCorrectElementNode: TextCorrectElementNode) => {
    const nodesInTextCorrect = $dfsWithinNode(textCorrectElementNode);

    // split the nodes into windows
    const windows: Array<Array<LexicalNode>> = [];
    let currentWindowNodes: Array<LexicalNode> = [];

    for (let i = 0; i < nodesInTextCorrect.length; i++) {
        const node = nodesInTextCorrect[i];
        if ($isWindowBarrierNode(node)) {
            windows.push(currentWindowNodes);
            currentWindowNodes = [];
        } else if ($isIgnorableNodeForSaving(node)) {
            continue;
        } else {
            currentWindowNodes.push(node);
        }
    }
    // push the last window that was built
    windows.push(currentWindowNodes);

    return windows;
};
